<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="tableEdit">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiSalestaffQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="员工售票权限查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 100px;">选择员工：</div>
						<a-select v-model="query.staffId" style="width: 100%;">
							<a-select-option v-for="(item,index) in staffList" :value="item.staffId" :key="index">{{item.staffName}}</a-select-option>
						</a-select>
					</div>
	
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiSalestaffQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
					
					</a-breadcrumb-item>
					
				</a-breadcrumb>
			
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="priceId" :loading="tableLoading" :pagination="false">
			
				<span slot="staffId" slot-scope="staffId">
					{{staffMap['yg'+staffId]}}
				</span>
				<span slot="rule" slot-scope="rule">
					{{rule.productName + '(' + rule.crowdtypeName + ')-' + rule.businesstypeName}}
				</span>
				<span slot="createTime" slot-scope="createTime">
					{{moment(createTime).format('YYYY-MM-DD HH:mm:ss')}}
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 修改弹窗 -->
		<a-modal title="权限管理" width="80%" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model style="" ref="addRuleForm" :model="editForm" :label-col="{span: 2}" :wrapper-col="{span: 22}" :rules="editRules">
				<a-form-model-item label="员工" has-feedback>
					<a-tag color="blue">{{staffMap['yg'+query.staffId]}}</a-tag>	
				</a-form-model-item>
				<a-form-model-item label="权限" has-feedback>
					<a-transfer :titles="['未选权限', '已选权限']" :data-source="allData" :render="item => item.title" :list-style="{ width: '40%', height: '300px',}" :target-keys="selectKeys" @change="handleChange"/>				
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				//售票员列表
				staffList: [],
				staffMap: {},
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					staffId: 0,
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'salestaffId', key:'salestaffId', align:'center'},
					{ title:'员工名称', dataIndex:'staffId', key:'staffId', align:'center', scopedSlots:{customRender:'staffId'}},
					{ title:'权限名称', key:'rule', align:'center', scopedSlots:{customRender:'rule'}},
					{ title:'添加时间', dataIndex:'createTime', key:'createTime', align:'center', scopedSlots:{customRender:'createTime'}},
					
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				editRules: {
					priceCode: [{ required: true, message: '产品代码不能为空', trigger: 'blur' }],
				
				},
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
				},
				// 修改弹窗-end
				//穿梭框
				allData: [],
				delKeys: [],
				selectKeys: [],
			};
		},
		methods: {
			//获取售票员列表
			async apiStaffList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiStaffList, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.staffList = res.data
					if(this.staffList.length > 0) {
						this.query.staffId = this.staffList[0].staffId
					}
					for(let i=0; i<res.data.length; i++) {
						this.staffMap['yg'+res.data[i].staffId] = res.data[i].staffName
					}
				} else {
					this.$message.error(res.msg)
				}
			},
			//--------------表格开始-搜索
			async apiSalestaffQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiSalestaffQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiSalestaffQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiSalestaffQueryList()
			},
	
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				this.editForm = items
				this.editVisible = true
			},
			async apiSalestaffEdit() {
				let addKeys = []
				for(let i=0; i<this.selectKeys.length; i++){
					let is = this.delKeys.indexOf(this.selectKeys[i])
					console.log(is)
					if(is > -1){
						this.delKeys.splice(is, 1)
					}else{
						addKeys.push(this.selectKeys[i])
					}
				}

				const { data: res } = await this.$http.post(this.navigation.apiSalestaffEdit, {
					staffId:this.query.staffId, delKeys:this.delKeys, addKeys:addKeys,
				});
				if (res.code == 200) {
					this.$message.success(res.msg)

					this.apiSalestaffQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.apiSalestaffEdit()
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.salestaffId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.productName + '(' + this.tableSelectedRows.crowdtypeName + ')-' + this.tableSelectedRows.businesstypeName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiSalestaffDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiSalestaffDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiSalestaffDel, {salestaffId: this.tableSelectedRows.salestaffId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiSalestaffQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				this.apiSalestaffGetRules()
				this.editVisible = true

			},
			//穿梭框-获取所有权限
			async apiSalestaffGetRules() {
				this.allData = []
				this.delKeys = []
				this.selectKeys = []
				const {
					data: res
				} = await this.$http.post(this.navigation.apiSalestaffGetRules, {staffId: this.query.staffId});
				if (res.code == 200) {
					this.allData = res.data.all
					for(let i=0; i<this.allData.length; i++){
						this.allData[i].key = this.allData[i].productId + '-' + this.allData[i].priceId
						this.allData[i].title = this.allData[i].productName + '(' + this.allData[i].crowdtypeName + ')-' + this.allData[i].businesstypeName
					}
					for(let i=0; i<res.data.self.length; i++){
						this.selectKeys.push(res.data.self[i].productId + '-' + res.data.self[i].priceId)
					}
					this.delKeys = JSON.parse(JSON.stringify(this.selectKeys))
				} else {
					this.$message.error(res.msg)
				}
			},
			handleChange(targetKeys, direction, moveKeys) {
				this.selectKeys = targetKeys;
			}
		
	
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiStaffList()
			setTimeout(()=>this.apiSalestaffQueryList(),500)
		}
	};
</script>

<style scoped>

</style>
